<template>
  <i-select :value="value" :clearable="false" @input="input">
    <i-option
      v-for="(item, key) in $t('pbx.stat.common.filter.group_by.values')"
      :key="key"
      :value="key"
      :label="item"
    />
  </i-select>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: 'date',
        validator: value => ['date', 'contact', 'sip_account', 'destination', 'type'].indexOf(value) !== -1
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
